"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.WhiteLabel = exports.SubmenuList = exports.SubmenuItem = exports.SubmenuHeader = exports.LogoutSection = exports.LogoText = exports.LogoMark = exports.Logo = exports.ItemText = exports.Item = exports.Icon = exports.Footer = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Box = _interopRequireDefault(require("../../Containers/Box"));
var _Icon = _interopRequireDefault(require("../../Icons/Icon"));
var _mixins = require("../../mixins");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var WhiteLabel = (0, _styledComponents["default"])(_Box["default"]).attrs(function (props) {
  return {
    d: "flex",
    alignItems: props.alignItems || "center",
    justifyContent: props.justifyContent || "center",
    w: props.w || props.width,
    h: props.h || props.height
  };
}).withConfig({
  displayName: "MenuStyles__WhiteLabel",
  componentId: "sc-4m439f-0"
})(["", ";padding:", " ", ";height:55px;width:100%;img{width:100%;height:auto;max-width:150px;}", " ", ""], _mixins.backgroundMixin, function (props) {
  return props.theme.spaces.s;
}, function (props) {
  return props.theme.spaces.base;
}, function (props) {
  return props.labelTall && (0, _styledComponents.css)(["img{width:auto;height:100%;}"]);
}, function (props) {
  return props.backgroundColorHex && (0, _styledComponents.css)(["background-color:", ";"], props.backgroundColorHex);
});

/* Logo *************************************************************** */
exports.WhiteLabel = WhiteLabel;
var LogoMark = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__LogoMark",
  componentId: "sc-4m439f-1"
})(["display:block;width:", ";height:", ";flex-shrink:0;"], function (props) {
  return props.theme.menu.logo;
}, function (props) {
  return props.theme.menu.logo;
});
exports.LogoMark = LogoMark;
var LogoText = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__LogoText",
  componentId: "sc-4m439f-2"
})(["height:", ";"], function (props) {
  return props.height || props.theme.menu.logo;
});
exports.LogoText = LogoText;
var Logo = (0, _styledComponents["default"])(_Box["default"]).attrs(function (props) {
  return {
    d: "flex",
    alignItems: props.alignItems || "center",
    justifyContent: props.justifyContent || "flex-start",
    w: props.w || props.width,
    h: props.h || props.height
  };
}).withConfig({
  displayName: "MenuStyles__Logo",
  componentId: "sc-4m439f-3"
})(["", ";padding-top:", ";padding-bottom:", ";padding-left:calc( ( 2 * ", " + ", " - ", " ) / 2 );padding-right:0;cursor:pointer;", ";svg{width:100%;height:100%;}", " ", ";"], (0, _mixins.colorMixin)("menuTextActive"), function (props) {
  return props.theme.spaces.m;
}, function (props) {
  return props.theme.spaces.m;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.theme.menu.logo;
}, _mixins.marginMixin, function (props) {
  return props.withSeparator && (0, _styledComponents.css)(["border-bottom:1px solid ", ";"], function (props) {
    return props.theme.colors.menuSeparator;
  });
}, _mixins.paddingMixin);

/* Items *************************************************************** */
exports.Logo = Logo;
var ItemText = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__ItemText",
  componentId: "sc-4m439f-4"
})(["color:", ";margin-left:", ";.is-active &{color:", ";font-weight:", ";}"], function (props) {
  return props.theme.colors.menuText;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.theme.colors.menuTextActive;
}, function (props) {
  return props.theme.fontWeights.semibold;
});
exports.ItemText = ItemText;
var Icon = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "MenuStyles__Icon",
  componentId: "sc-4m439f-5"
})(["font-size:", ";color:", ";"], function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.theme.colors.menuIcon;
});
exports.Icon = Icon;
var menuLinkMixin = (0, _styledComponents.css)(["font-size:", ";text-decoration:none;color:", ";position:relative;cursor:pointer;white-space:nowrap;&:hover{color:", ";", "{color:currentColor;}}&.is-active{color:", ";", "{color:currentColor;}}"], function (props) {
  return props.theme.menu.fontSize;
}, function (props) {
  return props.theme.colors.menuText;
}, function (props) {
  return props.theme.colors.menuIconActive;
}, Icon, function (props) {
  return props.theme.colors.menuIconActive;
}, Icon);
var Item = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__Item",
  componentId: "sc-4m439f-6"
})(["", ";display:flex;align-items:center;justify-content:flex-start;padding:", " ", ";", ""], menuLinkMixin, function (props) {
  return props.theme.menu.pV;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.hasSubmenu && (0, _styledComponents.css)(["flex-direction:column;align-items:flex-start;"]);
});

/* SubMenu  *************************************************************** */
exports.Item = Item;
var SubmenuHeader = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__SubmenuHeader",
  componentId: "sc-4m439f-7"
})(["display:flex;", "{margin-right:", ";.is-active &{color:", ";font-weight:", ";}}"], ItemText, function (props) {
  return props.theme.spaces.xs;
}, function (props) {
  return props.theme.colors.menuText;
}, function (props) {
  return props.theme.fontWeights.normal;
});
exports.SubmenuHeader = SubmenuHeader;
var SubmenuList = _styledComponents["default"].ul.withConfig({
  displayName: "MenuStyles__SubmenuList",
  componentId: "sc-4m439f-8"
})(["display:block;margin:0;margin-left:calc( ", " + ", " );", " li{margin-top:", ";}"], function (props) {
  return props.theme.menu.iconSize;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return (!props.submenuOpen || !props.isMenuOpen) && (0, _styledComponents.css)(["display:none;"]);
}, function (props) {
  return props.theme.menu.pV;
});
exports.SubmenuList = SubmenuList;
var SubmenuItem = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__SubmenuItem",
  componentId: "sc-4m439f-9"
})(["", ";opacity:0.8;&.is-active{opacity:1;}"], menuLinkMixin);

/* Logout  *************************************************************** */
exports.SubmenuItem = SubmenuItem;
var LogoutSection = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__LogoutSection",
  componentId: "sc-4m439f-10"
})(["position:relative;padding-top:calc(1.5 * ", ");&::before{content:\"\";position:absolute;width:calc(100% - 2 * ", ");height:1px;background-color:", ";top:", ";left:50%;transform:translateX(-50%);}"], function (props) {
  return props.theme.menu.pV;
}, function (props) {
  return props.theme.menu.pH;
}, function (props) {
  return props.theme.colors.menuSeparator;
}, function (props) {
  return props.theme.menu.pV;
});

/* Footer  *************************************************************** */
exports.LogoutSection = LogoutSection;
var Footer = _styledComponents["default"].div.withConfig({
  displayName: "MenuStyles__Footer",
  componentId: "sc-4m439f-11"
})(["flex-grow:1;cursor:pointer;display:flex;align-items:flex-end;&:hover ", "{color:", ";}"], Icon, function (props) {
  return props.theme.colors.menuIconActive;
});
exports.Footer = Footer;
var Wrapper = _styledComponents["default"].nav.withConfig({
  displayName: "MenuStyles__Wrapper",
  componentId: "sc-4m439f-12"
})(["height:100%;display:flex;flex-direction:column;justify-content:flex-start;overflow-x:hidden;width:", ";transition:width 0.5s ease-in-out;border-right:1px solid ", ";", ";", " ", " ", ""], function (props) {
  return props.maxWidth || "182px";
}, function (props) {
  return props.theme.colors.border;
}, function (props) {
  return !props.isOpen && (0, _styledComponents.css)(["width:calc(2 * ", " + ", ");transition:width 0.2s ease-out;", "{opacity:0;width:0;}", ",", "{opacity:0;margin-left:0;}"], props.theme.menu.pH, props.theme.menu.iconSize, WhiteLabel, ItemText, LogoText);
}, function (props) {
  return props.noBorder && (0, _styledComponents.css)(["border-right:none;"]);
}, function (props) {
  return props.activeVariant && props.activeVariant === "dot" && (0, _styledComponents.css)(["", "{&.is-active::before{content:\"\";display:block;width:4px;height:4px;background-color:currentColor;border-radius:50%;position:absolute;top:50%;left:", ";transform:translateY(-50%);}}"], Item, function (props) {
    return props.theme.spaces.s;
  });
}, function (props) {
  return props.activeVariant && props.activeVariant === "borderAndHighlight" && (0, _styledComponents.css)(["", "{&.is-active{background-color:", ";&::before{content:\"\";display:block;width:3px;height:100%;background-color:", ";position:absolute;top:0;left:0;}}}"], Item, props.theme.colors.menuBackgroundActive, props.theme.colors.menuBorderActive);
});
exports.Wrapper = Wrapper;